customElements.get("product-form") ||
    customElements.define(
        "product-form",
        class t extends HTMLElement {
            constructor() {
                super(),
                    (this.form = this.querySelector("form")),
                    (this.formIdInput = this.form.querySelector("[name=id]")),
                    (this.formIdInput.disabled = !1),
                    this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                    (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
                    (this.submitButton = this.querySelector('[type="submit"]')),
                    document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
                    (this.bundleDeals = document.getElementById(`bundle-deals-${this.dataset.section}`)),
                    (this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`)),
                    (this.variantInputs = this.form.querySelector(".product-form__variants"));
            }
            onSubmitHandler(t) {
                if ((t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled"))) return;
                this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
                let e = !1;
                if ((this.variantInputs && (this.variantInputs.innerHTML = ""), this.bundleDeals)) {
                    let r = "";
                    e = !0;
                    for (let s = 0; s < this.bundleDeals.formVariants.length; s++) {
                        let i = this.bundleDeals.formVariants[s];
                        r += `<input type="hidden" name="items[${s}][quantity]" value="${i.quantity}"><input type="hidden" name="items[${s}][id]" value="${i.id}">`;
                    }
                    this.variantInputs.innerHTML = r;
                } else if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants.length > 0) {
                    let a = "";
                    e = !0;
                    for (let n = 0; n < this.quantityBreaks.formVariants.length; n++) {
                        let o = this.quantityBreaks.formVariants[n];
                        a += `<input type="hidden" name="items[${n}][quantity]" value="${o.quantity}"><input type="hidden" name="items[${n}][id]" value="${o.id}">`;
                    }
                    this.variantInputs.innerHTML = a;
                }
                var d = fetchConfig("javascript");
                (d.headers["X-Requested-With"] = "XMLHttpRequest"), delete d.headers["Content-Type"];
                var u = new FormData(this.form);

  const isMainProductForm = this.closest(".product__info-wrapper") !== null;
 const bundleCheckbox = document.querySelector(".custom-bundle-widget__subscription-checkbox");

if (isMainProductForm && bundleCheckbox && bundleCheckbox.checked) {
  try {
    const extraProductsJSON = document.getElementById("extra-products-list")?.textContent;
    if (extraProductsJSON) {
      const extraProducts = JSON.parse(extraProductsJSON);
      console.log("extraProducts", extraProducts)

      // Find highest current items[N] index
      let maxIndex = -1;
      for (const key of u.keys()) {
        const m = key.match(/^items\[(\d+)\]\[id\]$/);
        if (m) maxIndex = Math.max(maxIndex, Number(m[1]));
      }
      let nextIndex = maxIndex + 1;

      extraProducts.forEach((product) => {
        if (product.variant_id) {
          u.append(`items[${nextIndex}][id]`, product.variant_id);
          u.append(`items[${nextIndex}][quantity]`, 1);
          u.append(`items[${nextIndex}][properties][_auto_added]`, 'true');
           if (product.selling_plan_id) {
            u.append(`items[${nextIndex}][selling_plan]`, product.selling_plan_id);
          }
          nextIndex++;
        }
      });
    }
  } catch (err) {
    console.error("Failed to add extra products:", err);
  }
}

                if (
                    (this.cart &&
                        (u.append(
                            "sections",
                            this.cart.getSectionsToRender().map((t) => t.id)
                        ),
                        u.append("sections_url", window.location.pathname),
                        this.cart.setActiveElement(document.activeElement)),
                    e)
                ) {
                    let h = this.dataset.options ? this.dataset.options.split(",") : [],
                        l = ["id", "quantity", ...h];
                    for (let c = 0; c < l.length; c++) u.delete(l[c]);
                }
                (d.body = u),
                    (this.skipCart = !1),
                    this.form.querySelector("[name=id]").dataset.skipCart && "true" === this.form.querySelector("[name=id]").dataset.skipCart && (this.skipCart = !0),
                    fetch(`${routes.cart_add_url}`, d)
                        .then((t) => t.json())
                        .then((t) => {
                            if (t.status) {
                                this.handleErrorMessage(t.description);
                                let e = this.submitButton.querySelector(".sold-out-message");
                                if (!e) return;
                                this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), e.classList.remove("hidden"), (this.error = !0);
                                return;
                            }
                            if (this.skipCart) {
                                window.location = "/checkout";
                                return;
                            }
                            if (!this.cart) {
                                window.location = window.routes.cart_url;
                                return;
                            }
                            this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" }), (this.error = !1);
                            let r = this.closest("quick-add-modal");
                            r
                                ? (document.body.addEventListener(
                                      "modalClosed",
                                      () => {
                                          setTimeout(() => {
                                              this.cart.renderContents(t);
                                          });
                                      },
                                      { once: !0 }
                                  ),
                                  r.hide(!0))
                                : this.cart.renderContents(t);
                        })
                        .catch((t) => {
                            console.error(t);
                        })
                        .finally(() => {
                            this.submitButton.classList.remove("loading"),
                                this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                                this.error || this.submitButton.removeAttribute("aria-disabled"),
                                this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                                  $('.cart_upsell_slider').slick({
                                    slidesToShow: 1.7,
                                    slidesToScroll: 1,
                                    infinite: false,
                                    arrows: false,
                                    dots: true
                                });
                        });
            }
            handleErrorMessage(t = !1) {
                (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                    this.errorMessageWrapper &&
                        ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t));
            }
        }
    );
